import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Projects.css';
import wc4 from '../assets/wc4.jpg';
import wc5 from '../assets/wc5.jpg';
import wc6 from '../assets/wc6.jpg';
import Header from './Header';
import Footer from './Footer'; // <-- import Footer

function Projects({ showHeader = true, showFooter = true }) { // <-- add footer prop
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  const projects = [
    {
      id: 1,
      title: "Commercial Office AC Setup",
      image: wc6,
      description: "Complete AC installation and setup for a modern commercial office building with centralized cooling system.",
      fullDescription: "In 2023, we successfully completed a comprehensive AC installation project for a state-of-the-art commercial office building. The project involved installing a centralized cooling system with multiple zones to maintain optimal temperature across different floors and departments. Our team designed and implemented custom ductwork to ensure efficient air distribution, while maintaining acoustic comfort in meeting rooms and workspaces."
    },
    {
      id: 2,
      title: "Residential Home Retrofit",
      image: wc5,
      description: "Modern AC system retrofit for luxury residential property with smart temperature control.",
      fullDescription: "Our team executed a complete AC retrofit for a luxury residential property in the heart of the city. The project involved replacing an outdated system with a modern, energy-efficient solution featuring smart temperature control capabilities. We installed a multi-zone system allowing individual room temperature adjustments, integrated with a mobile app for remote management. The installation was completed with minimal disruption to the residents."
    },
    {
      id: 3,
      title: "Industrial Facility Cooling",
      image: wc4,
      description: "Heavy-duty cooling system for industrial manufacturing facility with specialized requirements.",
      fullDescription: "We undertook a challenging project to design and install a robust cooling system for a large industrial manufacturing facility. The system required specialized components to handle the unique demands of the production environment, including high cooling capacity and continuous operation capability. Our team also provided comprehensive maintenance contracts to ensure optimal performance and minimal downtime."
    }
  ];

  const handleProjectClick = (project) => {
    navigate(`/project/${project.id}`, { state: { project } });
  };

  return (
    <>
      {showHeader && <Header />} {/* Conditional Header */}
      
      <div className="projects-container">
        <div className="projects-header">
          <h1>OUR PROJECTS</h1>
          <p>
            Delivering reliable and high-quality AC installation and maintenance solutions for residential and commercial clients across India, ensuring comfort and efficiency in every project.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`project-card ${hoveredId === project.id ? 'hovered' : ''}`}
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => handleProjectClick(project)}
            >
              <div className="project-image-section">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project-title-section">
                <h3>{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showFooter && <Footer />} {/* Conditional Footer */}
    </>
  );
}

export default Projects;
